import Time from "@/../bower_components/teknisavuecomponents/assets/utils/Time";

class MarcacaoUtils {
  public static fixDateId(
    dateId: string
  ): string {
    if (dateId === 'DA') {
      return 'FA';
    }

    if (dateId === 'DS') {
      return 'FS';
    }

    if (dateId === 'DC') {
      return 'FC';
    }

    return dateId;
  }

  public static fixTimeByDateId(
    time: Time,
    dateId: string
  ): Time {
    const time24Hours = Time.fromString('24:00');
    const time00Hour = Time.fromString('00:00')

    if (dateId === 'FA') {
      return time.sum(time24Hours);
    }

    if (dateId === 'FS') {
      return time.subtract(time24Hours);
    }

    return time.sum(time00Hour);
  }

  public static formatMarcacaoTime(
    timeStr: string,
    valueIfTimeNotSet: string = null,
  ): string {
    if (!timeStr) {
      return valueIfTimeNotSet;
    }

    const time = Time.fromString(timeStr);
    const dayMaxTime = Time.fromString('23:59');

    const min = Time.min(time, dayMaxTime);
    const minStr = min.toString();

    return minStr;
  }
}

export default MarcacaoUtils;
